import { Http } from "../../../support";

const initialState = {
  busy: false,
  data: {},
  error: undefined,
  result: undefined,
  isValid: false
};

const info = async (store, id, meta = {}) => {
  store.setState((state) => {
    state.app.prefacturas.info.busy = true;
  });

  const params = {
    ...meta,
    include: 'field',
  }

  try {
    const response = await Http.get(`api/prefacturas/${id}`, { params });

    store.setState((state) => {
      state.app.prefacturas.info.data = response.data;
      state.app.prefacturas.info.busy = false;
    });

    return response.data;
  } catch (error) {
    store.setState((state) => {
      state.app.prefacturas.info.error = error.data || error;
      state.app.prefacturas.info.busy = false;
    });
  }
}

const resetError = (store) => state => {
  state.app.prefacturas.info.error = undefined;
};

const reset = (store) => state => {
  state.app.prefacturas.info = { ...initialState };
};

const actions = {
  info,
  reset,
  resetError
}

const PrefacturaInfoStore = {
  state: () => initialState,
  actions
}

export default PrefacturaInfoStore;